import { useState, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { RoleProvider, useRole } from './contexts/RoleContext'
import { ThemeProvider } from './contexts/ThemeContext'
import BottomNavigation from './components/feature/BottomNavigation'
import SplashScreen from './components/feature/SplashScreen'
import RoleSelectionScreen from './components/feature/RoleSelectionScreen'

type AppPhase = 'splash' | 'login' | 'app'

function AppContent() {
  const { role, authLoading } = useRole()

  const [phase, setPhase] = useState<AppPhase>(() => {
    if (!sessionStorage.getItem('splash_shown')) return 'splash'
    return 'login'
  })

  // When auth resolves: if user is logged in → go to app, else → login
  useEffect(() => {
    if (authLoading) return
    if (role !== null) {
      setPhase('app')
    } else {
      setPhase('login')
    }
  }, [role, authLoading]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSplashDone = () => {
    sessionStorage.setItem('splash_shown', 'true')
    // After splash, check if already logged in
    if (role !== null) {
      setPhase('app')
    } else {
      setPhase('login')
    }
  }

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-2xl">
            <i className="ri-loader-4-line text-blue-500 text-2xl animate-spin"></i>
          </div>
          <p className="text-xs text-gray-400 font-medium">AutoLink</p>
        </div>
      </div>
    )
  }

  return (
    <>
      {phase === 'splash' && <SplashScreen onDone={handleSplashDone} />}
      {phase === 'login' && <RoleSelectionScreen />}
      {phase === 'app' && (
        <div className="min-h-screen bg-gray-50">
          <AppRoutes />
          <BottomNavigation />
        </div>
      )}
    </>
  )
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ThemeProvider>
        <RoleProvider>
          <div
            className="min-h-screen w-full flex justify-center dark:bg-gray-950"
            style={{ background: 'linear-gradient(135deg, #e8edf5 0%, #dce4f0 100%)' }}
          >
            <div
              className="relative w-full bg-white dark:bg-gray-900 shadow-2xl overflow-hidden"
              style={{ maxWidth: '430px', minHeight: '100vh' }}
            >
              <AppContent />
            </div>
          </div>
        </RoleProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
